import React, { useContext, useState } from 'react';

import { languageOptions } from '../../languages';
import { LanguageContext } from '../../containers/Language';
import classes from "./LaguageSelector.module.scss";
import "./styleCustomizer.css";
import Select from 'react-select'

export default function LanguageSelector() {
  const { userLanguage, userLanguageChange } = useContext(LanguageContext);
  const [selectedValue, setSelectedValue] = useState(1);

  // set selected language by calling context method
  const handleLanguageChange = e => userLanguageChange(e.value);

  const lang = Object.entries(languageOptions).map(([id, name]) => (
      { value: id, label: name }
  ))

  return (
    // <select className={classes.langSelect}
    //   onChange={handleLanguageChange}
    //   value={userLanguage}
    // >
    //   {Object.entries(languageOptions).map(([id, name]) => (
    //     <option key={id} value={id}>{name}</option>
    //   ))}
    // </select>

    <Select className={classes.langSelect}
      onChange={handleLanguageChange} 
      isSearchable={false}
      isClearable={false}
      placeholder='AZ'
      value={lang.find(obj => obj.value === userLanguage)}
      options={lang} />
  );
};
